// Tiny one-shot toast. Sits at bottom-right, autohides after 3s.
// Usage:
//   const [toast, showToast] = useToast();
//   showToast('Added');
//   {toast}   // render slot

import { useCallback, useState } from 'react';

let toastCounter = 0;

export function useToast() {
        const [entries, setEntries] = useState([]);

        const showToast = useCallback((message, opts = {}) => {
                const id = ++toastCounter;
                const kind = opts.kind || 'default';
                setEntries((prev) => [...prev, { id, message, kind }]);
                const ttl = opts.ttl || 3000;
                setTimeout(() => {
                        setEntries((prev) => prev.filter((e) => e.id !== id));
                }, ttl);
        }, []);

        const toast = (
                <div
                        aria-live="polite"
                        data-testid="toast-stack"
                        className="fixed z-[9999] bottom-6 right-6 flex flex-col gap-2 pointer-events-none"
                >
                        {entries.map((e) => (
                                <div
                                        key={e.id}
                                        data-testid={`toast-${e.kind}`}
                                        className={
                                                'pointer-events-auto min-w-[220px] max-w-[360px] border font-mono text-[12px] tracking-[0.16em] uppercase py-3 px-4 backdrop-blur ' +
                                                (e.kind === 'success'
                                                        ? 'border-[#FF9F1C] bg-[#FF9F1C]/95 text-[#0A0A0A]'
                                                        : 'border-white/20 bg-black/90 text-white')
                                        }
                                >
                                        {e.message}
                                </div>
                        ))}
                </div>
        );

        return [toast, showToast];
}
